/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';
import dayjs from 'dayjs';

import { Grid, Form, Header } from '@mairistem/composants';

import { OPTIONS_EXEMPTION, OPTIONS_RECENSE } from '@/constants';
import type { ListeRecensement, Exemption, Individu } from '@/types';

import PanelButtonEdition from '../PanelButtonEdition';
import RecensementModal from './RecensementModal';

interface RecensementPanelProps {
  demandeExemption: Exemption;
  recensement: ListeRecensement;
  numeroRecensement: number;
  trimestreRecensement: number;
  // dateRecensement: Date;
  dateRecensement: string;
  anneeRecensement: number;
  recense: Partial<Individu>;
  updated: boolean;
  onChange: (data: Partial<Individu>) => void;
  onSave: () => Promise<void>;
  onRollback: () => void;
}

const RecensementPanel = (props: RecensementPanelProps) => {
  const {
    demandeExemption,
    recensement,
    numeroRecensement,
    trimestreRecensement,
    dateRecensement,
    anneeRecensement,
    recense,
    updated,
    onChange,
    onSave,
    onRollback,
  } = props;

  const [modalEditionOpen, setModalEditionOpen] =
    React.useState<boolean>(false);

  const renderPeriodeDate = React.useMemo(
    () =>
      `${recense?.trimestreRecensement}${recense?.trimestreRecensement === 1 ? 'ère' : 'ème'} trimestre en date du ${dayjs(recense?.dateRecensement).format('DD/MM/YYYY')}`,
    [recense?.dateRecensement, recense?.trimestreRecensement],
  );

  const handleClose = React.useCallback(() => {
    setModalEditionOpen(false);
  }, []);

  const handleCancel = React.useCallback(() => {
    onRollback();
    handleClose();
  }, [handleClose, onRollback]);

  return (
    <Grid as={Form}>
      <Grid.Row>
        <Header as="h5" color="blue" style={{ margin: 0 }}>
          INFORMATIONS SUR LE RECENSEMENT
        </Header>
        <PanelButtonEdition
          onClick={() => {
            setModalEditionOpen(true);
          }}
        />
        {modalEditionOpen && (
          <RecensementModal
            demandeExemption={demandeExemption}
            recensement={recensement}
            trimestreRecensement={trimestreRecensement}
            dateRecensement={dateRecensement}
            numeroRecensement={numeroRecensement}
            anneeRecensement={anneeRecensement}
            updated={updated}
            onChange={onChange}
            onSave={onSave}
            onClose={handleClose}
            onCancel={handleCancel}
          />
        )}
      </Grid.Row>
      <Grid.Row>
        <Grid.Column
          mobile={16}
          tablet={12}
          computer={8}
          largeScreen={5}
          widescreen={4}
        >
          <span>
            <b>Trimestre et date : </b>
          </span>
          <span>{renderPeriodeDate}</span>
        </Grid.Column>
        <Grid.Column
          mobile={16}
          tablet={4}
          computer={8}
          largeScreen={3}
          widescreen={4}
        >
          <span>
            <b>N° ordre : </b>
          </span>
          <span>
            {recense?.numeroRecensement === 0
              ? 'Non numéroté'
              : recense?.numeroRecensement !== 0 &&
                  recense?.trimestre?.dateNumerotation
                ? `${recense?.numeroRecensement} (Numéroté le ${dayjs(recense?.trimestre?.dateNumerotation).format('DD/MM/YYYY')})`
                : recense?.numeroRecensement}
          </span>
        </Grid.Column>
        <Grid.Column
          mobile={16}
          tablet={5}
          computer={5}
          largeScreen={3}
          widescreen={4}
        >
          <span>
            <b>Liste : </b>
          </span>
          <span>
            {OPTIONS_RECENSE.find(
              (option) => option.value === recense?.recensement,
            )?.text || 'Omis administratif'}
          </span>
        </Grid.Column>
        <Grid.Column
          mobile={16}
          tablet={11}
          computer={11}
          largeScreen={5}
          widescreen={4}
        >
          <span>
            <b>Demande d&apos;exemption : </b>
          </span>
          <span>
            {OPTIONS_EXEMPTION.find(
              (option) => option.value === recense?.demandeExemption,
            )?.text || 'Aucune'}
          </span>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default RecensementPanel;
